import { MenuItem, Select } from "@mui/material";
import React from "react";
import GPS from "../assets/images/svg/gps_fixed.svg";
import Search from "../assets/images/svg/search_blue.svg";
import Copy from "../assets/images/svg/copy.svg";
import Hide from "../assets/images/svg/hide.svg";
import { DateBox } from "devextreme-react";
import PhoneInput from "react-phone-input-2";
import { Controller } from "react-hook-form";

const Input = React.forwardRef(
  (
    {
      type,
      label,
      options = [],
      getOptionLabel = (option) => option.name,
      getOptionValue = (option) => option.id,
      id,
      defaultVal,
      control,
      name,
      location,
      search,
      copy,
      Oncopy,
      error,
      bold,
      readonly,
      require,
      checked,
      onLocationIconClick,
      ...props
    },
    ref
  ) => {
    const [show, setShow] = React.useState(false);
    switch (type) {
      case "select":
        return (
          <div className={`select-div ${readonly ? "readonly" : ""}`}>
            <label
              className={`lapel-input ${error ? "error" : ""}  ${readonly ? "readonly" : ""} ${
                props.dashed ? "dashed" : ""
              }`}
              htmlFor="id"
            >
              {label && (
                <span className="select-span">
                  {label} {require && <small className="star-require">*</small>}
                </span>
              )}
              <Select id={id} disabled={readonly} name={name} inputRef={ref} defaultValue={defaultVal}
            {...props}>
                 <MenuItem value="" disabled > -- Select one --</MenuItem>
                {options?.map((op) => (
                  <MenuItem key={getOptionValue(op)} value={getOptionValue(op)}>
                    {getOptionLabel(op)}
                  </MenuItem>
                ))}
              </Select>
            </label>
            <span className="text-error">{error}</span>
          </div>
        );
      case "check":
        return (
          <label
            htmlFor={id}
            className={`label-check ${bold ? "bold" : ""} ${readonly ? "readonly" : ""}`}
          >
            <input id={id} disabled={readonly} checked={checked} type="checkbox" />
            <span className="span-title">{label}</span>
          </label>
        );
      case "password":
        return (
          <div className="input-div">
            <label
              className={`lapel-input ${error ? "error" : ""} ${readonly ? "readonly" : ""}`}
              htmlFor={id}
            >
              <span>
                {label} {require && <small className="star-require">*</small>}
              </span>
              <input
                name={name}
                disabled={readonly}
                type={show || type || "text"}
                id={id}
                placeholder={props.placeholder}
                {...props}
                ref={ref}
              />
              <img
                className="img-password"
                src={Hide}
                alt="hide"
                onClick={() => setShow((s) => !s)}
              />
            </label>
            {error && <span className="text-error">{error}</span>}
            {props.warning && <span className="text-warning">{props.warning}</span>}
          </div>
        );
      case "date":
        return (
          <div className={`input-div ${readonly ? "readonly" : ""}`}>
            <label className="input-date">
              {label ? (
                <span>
                  {label} {require ? <small className="star-require">*</small> : ""}
                </span>
              ) : null}
              <DateBox type="datetime" disabled={readonly} name={name} {...props} />
            </label>
            {error && <span className="text-error">{error}</span>}
          </div>
        );

      case "phone":
        return (
          <div className={`input-div ${readonly ? "readonly" : ""}`}>
            <label
              className={`lapel-input ${error ? "error" : ""}  ${readonly ? "readonly" : ""} ${
                props.dashed ? "dashed" : ""
              }`}
            >
              {label ? (
                <span>
                  {label} {require ? <small className="star-require">*</small> : ""}
                </span>
              ) : null}
              {control ? (
                <Controller
                  control={control}
                  name={name}
                  render={({ field, fieldState }) => (
                    <PhoneInput
                      country="eg"
                      disabled={readonly}
                      {...field}
                      isValid={!fieldState.error}
                    />
                  )}
                />
              ) : (
                <PhoneInput disabled={readonly} country="eg" {...props} />
              )}
            </label>
            {error && <span className="text-error">{error}</span>}
          </div>
        );

      default:
        return (
          
          <div className="input-div">
            <label
              className={`lapel-input ${error ? "error" : ""}  ${readonly ? "readonly" : ""} ${
                props.dashed ? "dashed" : ""
              }`}
              htmlFor={id}
            >
              {label ? (
                <span>
                  {label} {require ? <small className="star-require">*</small> : ""}
                </span>
              ) : (
                ""
              )}
              <input
                disabled={readonly}
                type={type || "text"}
                id={id}
                name={name}
                placeholder={props.placeholder}
                {...props}
                ref={ref}
                dir="auto"
              />
              {location ? <img className="location" onClick={onLocationIconClick} src={GPS} alt="GPS" /> : ""}
              {search ? <img className="iconSearch" src={Search} alt="Search" /> : ""}
              {copy ? <img className="iconCopy" src={Copy} alt="copy" onClick={Oncopy} /> : ""}
            </label>
            <span className="text-error">{error}</span>
          </div>
        );
    }
  }
);

export default Input;
